import { Outlet } from 'react-router-dom';
import React, {useState, useEffect} from 'react';

import LeftHeader from '../../generals-components/headers/left-header';
import Footer from '../../generals-components/footer/footer';

async function checkUserSession() {
    const response = await fetch('/api/check-token', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
    });

    if (response.ok) {
        return true;
    } else {
        return false;
    }
}

function LegalsLayout() {
    const [isUserLogged, setIsUserLogged] = useState(false)
    const [currentPage, setCurrentPage] = useState("Privacy Policy")

    useEffect(() => {
        async function checkIfUserIsLogged() {
            setIsUserLogged(await checkUserSession())
        }

        checkIfUserIsLogged()
    }, [])

    return (
        <div className="relative flex h-auto min-h-screen w-full flex-col group/design-root">
            <div className="layout-container flex h-full grow flex-col">
                <LeftHeader isUserLogged={isUserLogged} setIsUserLogged={setIsUserLogged}/>

                <Outlet context={{isUserLogged, setIsUserLogged, setCurrentPage}}/>

                <Footer currentPage={currentPage}/>
            </div>
        </div>
    );
}

export default LegalsLayout;